// extracted by mini-css-extract-plugin
module.exports = {"column":"Home_column__l9QPg","item":"Home_item__11QXh","header":"Home_header__1rp7N","copydoclink":"Home_copydoclink__3GnuS","description":"Home_description__2Et6N"};